import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BaseModel} from "../../../infrastructure/models/base-model";
import classNames from "classnames";
import styles from "./styles/dropdown.module.scss";
import {ArrowChevronRequestParams} from "../../icons/arrow-chevron.request-params";
import {SVGImage} from "../image/svg-image";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../app/consts/colors";

export class DropdownHeaderComponentProps extends BaseProps {
  className: String;
  containerClassName: String;
  opened: Boolean;
  expandable: Boolean;
  selectedItem: BaseModel;
  ListItem: React.Component;
  listItemProps: Object;
  arrowUpClassName: String;
  arrowDownClassName: String;
  arrowContainerClassName: String;
  arrowColor: String;
  toggleOpen: Function;
}

export const DropdownHeader = (props: DropdownHeaderComponentProps) => {
  const arrowClassName: String = props.opened ? props.arrowUpClassName : props.arrowDownClassName;

  const containerProps = {
    onClick: () => {
      props.toggleOpen()
    },
    className: props.containerClassName
  }

  const itemProps = {
    className: props.className,
    item: props.selectedItem,
    ...props.listItemProps,
    disableLink: true,
    isHeader: true
  }

  const svgProps = {
    className: classNames(arrowClassName, styles.arrow, {[styles.arrow_opened]: props.opened}),
    src: new ArrowChevronRequestParams(12, 12, '_RIGHT'),
    fillcolor: useThemeColor(COLORS.textSecondary)
  }

  return (
    <div {...containerProps}>
      <props.ListItem {...itemProps}/>
      {
        props.expandable && <div className={classNames(styles.arrow_container, props.arrowContainerClassName)}>
          <SVGImage {...svgProps}/>
        </div>
      }
    </div>
  )
}
